import { useBundlesWithProduct } from '@/services/bundles/useProductInBundles';
import { FC, useMemo } from 'react';
import { FiInfo } from 'react-icons/fi';
import { Tooltip } from 'react-tooltip';

interface SelectedIndicatorProps {
  productId: string;
}

export const BundleSelectedProductIndicator: FC<SelectedIndicatorProps> = ({ productId }) => {
  const bundlesWithProduct = useBundlesWithProduct(productId);

  const selectedSuffix = useMemo(
    () => (bundlesWithProduct.length === 1 ? bundlesWithProduct[0].name : `${bundlesWithProduct.length} bundles`),
    [bundlesWithProduct]
  );

  return (
    <div className="bg-primary-700 text-white flex justify-center items-center py-1 font-semibold">
      <a className="flex space-x-1" data-tooltip-id={`selected-tooltip-${productId}`}>
        <span>Selected</span>
        {bundlesWithProduct.length > 0 && (
          <div className="flex space-x-1">
            <span>-</span>
            <div className="flex space-x-1 items-center">
              <span>{selectedSuffix}</span> {bundlesWithProduct.length > 1 && <FiInfo />}
            </div>
          </div>
        )}
      </a>
      {bundlesWithProduct.length > 1 && (
        <Tooltip id={`selected-tooltip-${productId}`}>
          <div className="space-y-1">
            {bundlesWithProduct.map(bundle => (
              <p key={`${productId}-${bundle.id}`}>{bundle.name}</p>
            ))}
          </div>
        </Tooltip>
      )}
    </div>
  );
};
